module.exports = __webpack_public_path__ + "img/img_hongbao2.cfd6566f.png";